<mat-button-toggle-group [ngModel]="value" (ngModelChange)="chooseOption($event)">
  @for (option of options; track option.id) {
    <mat-button-toggle [value]="option.id">{{ option.labelTranslationKey | translate }}</mat-button-toggle>
  }
</mat-button-toggle-group>
